import { Component, Input } from '@angular/core';
import { LhvCalculatorComponent } from './lhv-calculator/lhv-calculator.component';
import { TfbankCalculatorComponent } from './tfbank-calculator/tfbank-calculator.component';
import { EstoCalculatorComponent } from './esto-calculator/esto-calculator.component';
import { InbankCalculatorComponent } from './inbank-calculator/inbank-calculator.component';
import { MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { TranslateDirective } from '@speedy/core';

@Component({
  selector: 'app-leasing-calculator',
  templateUrl: './leasing-calculator.component.html',
  styleUrls: ['./leasing-calculator.component.scss'],
  standalone: true,
  imports: [
    MatTabGroup,
    MatTab,
    MatTabLabel,
    TranslateDirective,
    InbankCalculatorComponent,
    EstoCalculatorComponent,
    TfbankCalculatorComponent,
    LhvCalculatorComponent,
  ],
})
export class LeasingCalculatorComponent {
  @Input() set productPrice(value: string) {
    this._productPrice = parseInt(value, 10);
  }

  @Input() isLhvVisible!: boolean;
  @Input() isInbankVisible!: boolean;
  @Input() isEstoVisible!: boolean;
  @Input() isTFbankVisible!: boolean;

  _productPrice!: number;
}
